import { PermissionKey } from '@evimo/types/enums/permission-key';

/** Asset-scoped incident list/tab and detail navigation require incidents:read. */
export function canViewAssetIncidents(
  hasPermission: (key: PermissionKey) => boolean,
): boolean {
  return hasPermission(PermissionKey.INCIDENTS_READ);
}

export function canNavigateToAssetIncidentDetails(
  hasPermission: (key: PermissionKey) => boolean,
): boolean {
  return canViewAssetIncidents(hasPermission);
}
